<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">コース編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">コース登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'course-id-edit' : 'course-add', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名</th>
            <td>{{ currentCourse.name }}</td>
          </tr>
          <tr>
            <th scope="row">コース名フリガナ</th>
            <td>{{ currentCourse.nameReading }}</td>
          </tr>
          <tr v-if="id">
            <th scope="row">コースID（自動生成）</th>
            <td>{{ currentCourse.uid }}</td>
          </tr>
          <tr>
            <th scope="row">確認テスト合格点数</th>
            <td>{{ currentCourse.testPassingScore }}点</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="コース情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header v-if="id">コース編集</template>
        <template v-slot:header v-else>コース登録</template>
        <template v-slot:body v-if="id">コースの登録情報の編集が完了しました！</template>
        <template v-slot:body v-else>コースの登録が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      errorMessage: null,
      isLoading: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      if (store.getters['course/existsUpdateRequiredParams']) {
        store.dispatch('course/fetchCourse', routeTo.params.id).then(() => {
          next();
        });
      } else {
        next({ name: 'course-id-edit', params: { id: routeTo.params.id } });
      }
    } else {
      if (store.getters['course/existsRegistrationRequiredParams']) {
        next();
      } else {
        next({ name: 'course-add' });
      }
    }
  },
  computed: {
    currentCourse() {
      if (this.course.editingCourse) {
        return this.course.editingCourse;
      } else {
        return this.course.course;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentCourse.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentCourse.brand);
    },
    ...mapState(['course']),
  },
  methods: {
    confirmRevised() {
      if (this.id) {
        // This path is for Editing existing Course flow
        this.$logger.debug('Need revise, go back to ID ' + this.id);
        this.$router.push({ name: 'course-id-edit', params: { id: this.id } });
      } else {
        // This path is for Adding new Course flow
        this.$logger.debug('Need revise, go back');
        this.$router.push({ name: 'course-add' });
      }
    },
    confirmSaved() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentCourse));
      if (this.id) {
        // This path is for Editing existing Course flow
        this.finishEditingCourse(this.id).then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.isLoading = true;
        // This path is for Adding new Course flow
        this.finishEditingCourse().then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        this.$router.push({ name: 'course-id-detail', params: { id: this.id } });
      } else {
        this.$router.push({ name: 'course' });
      }
    },
    ...mapActions('course', ['finishEditingCourse']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
